<template
  ><v-card class="p-4">
    <v-card-title>
      Les vidéos
      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher sur les Noms, Thème, License type..."
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>

      <export-btn entity="videos"/>

      <!-- bouton trash à partir de 2 checkbox de cocher -->
      <v-btn v-if="selected.length >= 2" class="mx-2" fab dark small color="red">
        <v-icon dark v-model="selected" small @click="deleteVideos(selected[0].video)">
          mdi-delete
        </v-icon>
      </v-btn>

      <router-link :to="{ name: 'creerVideo' }">
        <v-btn class="mx-2" fab dark small color="indigo">
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </router-link>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="videos"
      :server-items-length="totalItems"
      :search-input.sync="search"
      :options.sync="options"
      :items-per-page="12"
      :page.sync="pagination.currentPage"
      hide-default-footer
      v-model="selected"
      :single-select="singleSelect"
      show-select
    >
      <template v-slot:item.outils="{ item }">
        <span>{{ getRootThemeWithChildren(item.theme).title }}</span>
      </template>
      <template v-slot:item.createdAt="{ item }">
        <span>{{ item.createdAt | moment }}</span>
      </template>
      <template v-slot:item.updatedAt="{ item }">
        <span>{{ item.updatedAt|moment }}</span>
      </template>
      <template v-slot:[`item.isVisible`]="{ item }">
        <span v-if="item.isVisible === true"
          ><i class="flaticon2-check-mark text-info"></i
        ></span>
        <span v-else><i class="flaticon2-delete text-danger"></i></span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <router-link
          :to="{ name: 'modifierVideo', params: { id: item.id, video: item } }"
        >
          <v-icon small class="mr-2">
            mdi-pencil
          </v-icon>
        </router-link>

        <v-icon small @click="deleteVideo(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>

    <template>
        <v-pagination
          v-model="pagination.currentPage"
          :length="pagination.pagesNumber"
          @input="onPageChange"
          class="text-center py-5"
        ></v-pagination>
    </template>
  </v-card>
</template>

<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import moment from "moment";
import { getRootThemeWithChildren } from "@/core/utils/userParentThemes";
import ExportBtn from "@/components/admin/exportBtn";

export default {
  name: "videos",
  components: { ExportBtn },
  data() {
    return {
      confirmDelete: false,
      loading: true,
      exportLoading: false,
      options: {},
      search: "",
      headers: [
        { text: "Nom", value: "title", align: "start" },
        { text: "Outil", value: "outils", align: "start" },
        { text: "Thème", value: "theme.title", align: "start" },
        { text: "Partenaire", value: "partner.name", align: "start" },
        //{ text: "License Type", value: "", align: "start" },
        { text: "En ligne", value: "isVisible", align: "center" },
        { text: "Créée le", value: "createdAt", align: "center" },
        { text: "Modifiée le", value: "updatedAt", align: "center" },
        { text: "Nb vues réelles", value: "realViews", align: "center" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
      totalItems: 0,
      deletedIndex: -1,
      model: null,
      singleSelect: false,
      selected: [], // Liste des droits utilisateurs sélectionnés dans le tableau
      videos: [],
      themes:[],
    };
  },
  filters: {
    moment: function(date) {
      const d = moment(date);
      return d.isValid() ? d.format("DD/MM/YYYY") : "";
    },
  },

  watch: {
    search(value) {
      this.search = value;
      this.pagination.currentPage = 1;
      this.getAllVideos();
    },
    options: {
      handler() {
        this.getAllVideos();
      },
      deep: true
    }
  },

  methods: {
    getAllVideos() {
      this.loading = true;
      let params = { search_title_or_theme: this.search };
      for (let i = 0; i < this.options.sortBy.length; i++) {
        params[`order[${this.options.sortBy[i]}]`] = this.options.sortDesc[i] ? 'desc' : 'asc';
      }
      //On récupère les vidéos, via api.service.js
      // On appelle la route "videos" de l'api, avec la methode get.
      Api.query("videos?page=" + this.pagination.currentPage, { params }).then((videos) => {
        this.videos = videos.data["hydra:member"]; //On rempli le tableau initialement vide par ce qu'on a récupéré
        this.totalItems = videos.data["hydra:totalItems"];
        this.pagination.pagesNumber = Math.ceil(this.totalItems / 12);
        this.loading = false;
      });
    },
    onPageChange() {
      //Pagination
      this.getAllVideos();
    },
    deleteVideo(item) {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer cette vidéo ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletedIndex = this.videos.indexOf(item);
          Api.delete("videos/" + item.id).then(() => {
            this.videos.splice(this.deletedIndex, 1),
              Swal.fire("Supprimé !", "Votre vidéo à été supprimée", "success"),
              this.getAllVideos();
          });
        }
      });
    },
    deleteVideos() {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer ces vidéos ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          const selectedItems = this.selected
          for(var i=0; i < selectedItems.length; i++){
            Api.delete("videos/" + selectedItems[i].id).then(() => { //TODO : appeler la fonction de callback. cf https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Promise/all
              Swal.fire(
                "Supprimé !",
                "Vos vidéos ont été supprimées",
                "success"
              );
              this.getAllVideos();
              this.selected = []
            });
          }
        }
      });
    },
    getRootThemeWithChildren: theme => getRootThemeWithChildren(theme),
  },
  mounted() {
    this.getAllVideos();
  },
};
</script>
